<template>
  <section>
    <b-message>
      Associate activities to <b>{{ packName }}</b>
    </b-message>

    <button
        class="button is-light"
        @click.prevent="cancel()"
    >
      <b-icon icon="chevron-left"></b-icon>
      <span>Back to packs list</span>
    </button>
    <button
        :disabled="!checkedRows.length"
        class="button field is-danger"
        @click.prevent="checkedRows = []"
    >
      <b-icon icon="delete"></b-icon>
      <span>Clear selection</span>
    </button>
    <button
        :disabled="!checkedRows.length"
        class="button is-success btn-margin"
        @click.prevent="associateRawActivities(checkedRows)"
    >
      <b-icon icon="link"></b-icon>
      <span>Associate the selected activities</span>
    </button>

    <hr/>

    <div class="field">
      <strong>{{ checkedRows.length }} selected activities</strong>
    </div>

    <div class="block">
      <b-field grouped>
        <b-input
            v-model="searchFilter"
            icon="magnify"
            expanded
            placeholder="Search for activities..."
            @input="searchFilterChanged">
        </b-input>
        <b-checkbox-button
            v-model="unlockModeFilter"
            :native-value="checkedUnlocked"
            style="padding-right: 4px"
            type="is-success"
            @input="geolocFilterChanged(checkedUnlocked)"
        >
          <b-icon :icon="iconUnlockFilter"></b-icon>
          <span>Unlocked activities</span>
        </b-checkbox-button>
        <b-checkbox-button
            v-model="unlockModeFilter"
            :native-value="checkedLocked"
            style="padding-right: 4px"
            type="is-danger"
            @input="geolocFilterChanged(checkedLocked)"
        >
          <b-icon :icon="iconLockedFilter"></b-icon>
          <span>Locked activities</span>
        </b-checkbox-button>
      </b-field>
      <b-field grouped position="is-right">
        <b-checkbox-button v-for="(typAct, index) in activityTypesArray"
                           :key="index"
                           v-model="activityTypeFilter"
                           :disabled="disabledActivities(typAct)"
                           :expanded="false"
                           :native-value="typAct"
                           style="padding-right: 4px"
                           type="is-info"
                           @input="searchFilterChanged"
        >
          <b-icon icon="check"></b-icon>
          <span>{{ typAct }}</span>
        </b-checkbox-button>
        <b-switch v-model="isHideSelected" type="is-info">
          Selected activities only
        </b-switch>
      </b-field>
    </div>

    <b-table
        :checked-rows.sync="checkedRows"
        :data="rawActivitiesFiltered"
        :row-class="getRowClass"
        checkable
    >
      <template slot-scope="props">
        <b-table-column class="centered-table-content" field="imgSrc" label="">
          <b-img :height="90" :img="props.row.imgSrc" :width="120"></b-img>
        </b-table-column>

        <b-table-column class="centered-table-content" field="name" label="Name" sortable>
          {{ props.row.name }}
          <b-tooltip :label="'Timer: ' + props.row.timeToAnswer + ' seconds'">
            <b-icon v-if="isThereATimer(props.row)" icon="clock-fast" type="is-danger"></b-icon>
          </b-tooltip>
        </b-table-column>

        <b-table-column class="centered-table-content" field="activityType" label="activityType">
          <b-tag type="is-success">{{ props.row.activityType }}</b-tag>
        </b-table-column>

        <b-table-column
            class="centered-table-content"
            field="content"
            label="Content"
            width="400px"
            v-html="displayContent(props.row)">
        </b-table-column>

        <b-table-column class="centered-table-content" field="points" label="Points">
          {{ props.row.points }}
        </b-table-column>

        <b-table-column class="centered-table-content" field="difficulty" label="Difficulty">
          {{ props.row.difficulty }}
        </b-table-column>

        <b-table-column class="centered-table-content" field="tags" label="Tags">
          <b-taglist>
            <b-tag
                v-for="(tag, index) in props.row.tags"
                :key="index"
                type="is-info">{{ tag }}
            </b-tag>
          </b-taglist>
        </b-table-column>
      </template>

      <template slot="bottom-left">
        <b>Selected activities</b>: {{ checkedRows.length }}
      </template>
    </b-table>

    <button
        class="button is-light btn-margin"
        @click.prevent="cancel()"
    >
      <b-icon icon="chevron-left"></b-icon>
      <span>Back to packs list</span>
    </button>
    <button
        :disabled="!checkedRows.length"
        class="button field is-danger btn-margin"
        @click.prevent="checkedRows = []"
    >
      <b-icon icon="delete"></b-icon>
      <span>Clear selection</span>
    </button>
    <button
        :disabled="!checkedRows.length"
        class="button is-success btn-margin"
        @click.prevent="associateRawActivities(checkedRows)"
    >
      <b-icon icon="link"></b-icon>
      <span>Associate the selected activities</span>
    </button>

  </section>
</template>

<script>

import displayHelper from '../../helpers/display-helper'
import packService from '../../services/packService'
import rawActivitiesHelper from '../../helpers/rawActivities-helper'
import BImg from '../single/BImg'
import activityTypesHelper from '../../enums/activityTypes'
import _ from 'lodash'

const CHECKED_LOCKED = 'locked'
const CHECKED_UNLOCKED = 'unlocked'

export default {
  name: 'activity-pack-association',
  components: {
    BImg,
  },
  data() {
    return {
      packName: this.$route.params.name,
      packId: this.$route.params.id,
      pack: null,
      isHideSelected: false,
      searchFilter: null,
      checkedRows: [],
      previousSelectedRawActivities: [],
      rawActivities: [],
      rawActivitiesFiltered: [],
      activityTypeFilter: [],
      unlockModeFilter: [],
      activityTypesArray: [],
      checkedLocked: CHECKED_LOCKED,
      checkedUnlocked: CHECKED_UNLOCKED,
      iconLockedFilter: 'check',
      iconUnlockFilter: 'check',
      columns: [
        {field: 'name'},
        {field: 'question'},
        {field: 'tags'},
      ],
    }
  },
  created() {
    this.isLoading = true
    const parent = this

    this.unlockModeFilter = [CHECKED_LOCKED, CHECKED_UNLOCKED]
    this.activityTypesArray = _.filter(Object.values(activityTypesHelper.ACTIVITY_TYPES), (type) => {
      return !activityTypesHelper.disabledActivities(type)
    }).sort()
    this.activityTypeFilter = this.activityTypesArray

    const packId = this.$route.params.id
    packService.getAllRawActivitiesForPack(packId)
        .then((data) => {
          this.rawActivities = data.rawActivities
          this.rawActivitiesFiltered = data.rawActivities
          this.previousSelectedRawActivities = data.checked
          data.rawActivities.map(rawActivity => {
            if (this.previousSelectedRawActivities.find((previousRawActivity) => {
              return previousRawActivity.rawActivityId === rawActivity.rawActivityId
            })) {
              this.checkedRows.push(rawActivity)
            }
          })
          this.isLoading = false
        })
        .then(() => {
          packService.getPackById(this.packId)
              .then((pack) => {
                this.pack = pack
              })
        })
        .catch((err) => {
          console.error(err)
          displayHelper.displayError(parent, 'Error fetching rawActivities: ' + err.message)
          this.isLoading = false
        })
  },
  methods: {
    searchFilterChanged() {
      if (this.searchFilter && this.searchFilter !== '') {
        let searchLower = this.searchFilter.toLowerCase()
        this.rawActivitiesFiltered = _.filter(this.rawActivities, r => {
          const rowContent = r.content
          let found = false
          for (let col of this.columns) {
            const theRow = col.field === 'question' ? rowContent : r[col.field]
            if (theRow) {
              found = theRow.toString().toLowerCase().indexOf(searchLower) >= 0 &&
                  this.includeGeolocInFilter(rowContent.unlocked_forced) &&
                  this.includeActivityTypeFilter(r['activityType'])
              if (found) {
                return true
              }
            }
          }
          return found
        })
      } else {
        this.rawActivitiesFiltered = _.filter(this.rawActivities, r => {
          return this.includeGeolocInFilter(r['content'].unlocked_forced) &&
              this.includeActivityTypeFilter(r['activityType'])
        })
      }
    },
    getRowClass(row, index) {
      if (this.isHideSelected && !this.checkedRows.includes(row)) {
        return 'is-hidden'
      }
      if (!this.isHideSelected && this.checkedRows.includes(row)) {
        return 'is-grounched'
      }
    },
    associateRawActivities(selectedRawActivities) {
      const parent = this

      let rawActivityIdsArray = []
      selectedRawActivities.forEach(selectedRawActivity => {
        rawActivityIdsArray.push(selectedRawActivity.rawActivityId)
      })

      this.pack.rawActivityIds = rawActivityIdsArray

      packService.updatePack(this.pack)
          .then(() => {
            displayHelper.displaySuccess(parent, 'Activities properly added to pack')
            this.$router.push({name: 'Packs'})
          })
          .catch(err => {
            displayHelper.displayError(parent, 'Error while adding activities to pack: ' + err.message)
            console.error(err)
          })
    },
    displayContent(rawActivity) {
      return rawActivitiesHelper.displayContentForActivityType(rawActivity)
    },
    cancel() {
      this.$router.push({name: 'Packs'})
    },
    resolve(path, obj) {
      return path.split('.').reduce(function (prev, curr) {
        return prev ? prev[curr] : null
      }, obj || self)
    },
    includeGeolocInFilter(lock) {
      if (lock && this.unlockModeFilter.includes(this.convLockMode(lock))) {
        return true
      } else if (!lock && this.unlockModeFilter.includes(this.convLockMode(lock))) {
        return true
      }
      return false
    },
    includeActivityTypeFilter(activityType) {
      return this.activityTypeFilter.includes(activityType)
    },
    geolocFilterChanged(lock) {
      if (this.unlockModeFilter.includes(lock)) {
        if (lock === CHECKED_UNLOCKED) {
          this.iconUnlockFilter = 'check'
        }
        if (lock === CHECKED_LOCKED) {
          this.iconLockedFilter = 'check'
        }
      } else {
        if (lock === CHECKED_UNLOCKED) {
          this.iconUnlockFilter = 'close'
        }
        if (lock === CHECKED_LOCKED) {
          this.iconLockedFilter = 'close'
        }
      }
      this.searchFilterChanged()
    },
    convLockMode(lockMode) {
      return lockMode === true ? CHECKED_UNLOCKED : CHECKED_LOCKED
    },
    disabledActivities(type) {
      return activityTypesHelper.disabledActivities(type)
    },
    isThereATimer(activity) {
      return !!activity.timeToAnswer && activity.timeToAnswer > 0
    },
  }
}

</script>

<style scoped>
.btn-margin {
  margin-left: 10px;
  margin-right: 10px;
}
</style>

<style>
tr.is-grounched {
  background: #bcd3f6 !important;
}
</style>
